<template>
    <v-content>
        <v-row>
            <v-col class="title"> Список пользователей </v-col>
            <v-col class="title">
                <div class="float-right">
                    <v-btn @click="addUsers()" color="primary">Подгрузить пользователей</v-btn>
                </div>
            </v-col>
        </v-row>
        <v-expansion-panels multiple>
            <v-expansion-panel>
                <v-expansion-panel-header class="table-filters-header"
                >Показатели</v-expansion-panel-header
                >
                <v-expansion-panel-content>
                    <v-col>
                        <v-row>
                            <v-col>
                                <v-checkbox color="info" v-model="showColumns.name" label="Имя"></v-checkbox>
                            </v-col>
                            <v-col>
                                <v-checkbox
                                    color="info"
                                    v-model="showColumns.second_name"
                                    label="Отчество"
                                ></v-checkbox>
                            </v-col>
                            <v-col>
                                <v-checkbox color="info" v-model="showColumns.surname" label="Фамилия"></v-checkbox>
                            </v-col>
                            <v-col>
                                <v-checkbox color="info" v-model="showColumns.sum" label="Сумма"></v-checkbox>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-checkbox
                                    color="info"
                                    v-model="showColumns.created_at"
                                    label="Дата регистрации"
                                ></v-checkbox>
                            </v-col>
                            <v-col>
                                <v-checkbox color="info" v-model="showColumns.isAdsfinSend" label="Постбек Adsfin"></v-checkbox>
                            </v-col>
                            <v-col>
                                <v-checkbox
                                    color="info"
                                    v-model="showColumns.utm_source"
                                    label="utm_source"
                                ></v-checkbox>
                            </v-col>
                            <v-col>
                                <v-checkbox
                                    color="info"
                                    v-model="showColumns.utm_campaign"
                                    label="utm_campaign"
                                ></v-checkbox>
                            </v-col>
                            <v-spacer></v-spacer>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-checkbox
                                    color="info"
                                    v-model="showColumns.aff_sub1"
                                    label="aff_sub1"
                                ></v-checkbox>
                            </v-col>
                            <v-col>
                                <v-checkbox
                                    color="info"
                                    v-model="showColumns.aff_sub2"
                                    label="aff_sub2"
                                ></v-checkbox>
                            </v-col>
                            <v-col>
                                <v-checkbox
                                    color="info"
                                    v-model="showColumns.aff_sub3"
                                    label="aff_sub3"
                                ></v-checkbox>
                            </v-col>
                            <v-col>
                                <v-checkbox
                                    color="info"
                                    v-model="showColumns.aff_sub4"
                                    label="aff_sub4"
                                ></v-checkbox>
                            </v-col>
                            <v-col>
                                <v-checkbox
                                    color="info"
                                    v-model="showColumns.aff_sub5"
                                    label="aff_sub5"
                                ></v-checkbox>
                            </v-col>
                            <v-spacer></v-spacer>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-checkbox
                                    color="info"
                                    v-model="showColumns.is_sms_blocked"
                                    label="Бан СМС?"
                                ></v-checkbox>
                            </v-col>
                            <v-col>
                                <v-checkbox
                                    color="info"
                                    v-model="showColumns.is_call_blocked"
                                    label="Бан ЗВОНКОВ?"
                                ></v-checkbox>
                            </v-col>
                            <v-col>
                                <v-checkbox
                                    color="info"
                                    v-model="showColumns.is_sms_white"
                                    label="White list СМС?"
                                ></v-checkbox>
                            </v-col>
                            <v-col>
                                <v-checkbox
                                    color="info"
                                    v-model="showColumns.is_call_white"
                                    label="White list ЗВОНКОВ?"
                                ></v-checkbox>
                            </v-col>
                            <v-col>
                                <v-checkbox
                                    color="info"
                                    v-model="showColumns.count_reg"
                                    label="Сколько регистраций?"
                                ></v-checkbox>
                            </v-col>
                            <v-spacer></v-spacer>
                        </v-row>
                    </v-col>

                </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
                <v-expansion-panel-header class="table-filters-header"
                >Фильтры</v-expansion-panel-header
                >
                <v-expansion-panel-content>
                    <v-col>
                        <v-row>
                            <v-col>
                                <TimePicker
                                    :model.sync="filters.registerDate.from"
                                    label="Дата регистрации: от"
                                    :outlined="true"
                                    :dense="true"
                                ></TimePicker>
                            </v-col>
                            <v-col>
                                <TimePicker
                                    :model.sync="filters.registerDate.to"
                                    label="Дата регистрации: до"
                                    :outlined="true"
                                    :dense="true"
                                ></TimePicker>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col>
                              <v-text-field
                                v-model="filters.id.value"
                                clearable
                                label="ID"
                                type="text"
                                outlined dense hide-details
                                @click:clear="filters.id.typeOfSearch=''"
                              >
                                <template v-slot:append>
                                  <b-dropdown style="margin-bottom:3px;" v-model="filters.id.typeOfSearch" aria-role="list">
                                        <template #trigger>
                                            <b-icon class="media-left" icon="help-circle" size="is-medium"></b-icon>
                                        </template>
                                        <div v-for="item in typeOfSearch">
                                            <b-dropdown-item :value="item.value" aria-role="listitem">
                                                <div class="media">
                                                    <b-icon class="media-left" icon="earth"></b-icon>
                                                    <div class="media-content">
                                                        <h3>{{ item.name }}</h3>
                                                    </div>
                                                </div>
                                            </b-dropdown-item>
                                        </div>
                                  </b-dropdown>
                                </template>
                              </v-text-field>
                            </v-col>
                            <v-col>
                              <v-text-field
                                v-model="filters.email.value"
                                clearable
                                label="Email"
                                type="text"
                                outlined dense hide-details
                                @click:clear="filters.email.typeOfSearch=''"
                              >
                                <template v-slot:append>
                                  <b-dropdown style="margin-bottom:3px;" v-model="filters.email.typeOfSearch" aria-role="list">
                                        <template #trigger>
                                            <b-icon class="media-left" icon="help-circle" size="is-medium"></b-icon>
                                        </template>
                                        <div v-for="item in typeOfSearch">
                                            <b-dropdown-item :value="item.value" aria-role="listitem">
                                                <div class="media">
                                                    <b-icon class="media-left" icon="earth"></b-icon>
                                                    <div class="media-content">
                                                        <h3>{{ item.name }}</h3>
                                                    </div>
                                                </div>
                                            </b-dropdown-item>
                                        </div>
                                  </b-dropdown>
                                </template>
                              </v-text-field>
                            </v-col>
                            <v-col>
                              <v-text-field
                                v-model="filters.phone.value"
                                clearable
                                label="Телефон"
                                type="text"
                                outlined dense hide-details
                                @click:clear="filters.phone.typeOfSearch=''"
                              >
                                <template v-slot:append>
                                  <b-dropdown style="margin-bottom:3px;" v-model="filters.phone.typeOfSearch" aria-role="list">
                                        <template #trigger>
                                            <b-icon class="media-left" icon="help-circle" size="is-medium"></b-icon>
                                        </template>
                                        <div v-for="item in typeOfSearch">
                                            <b-dropdown-item :value="item.value" aria-role="listitem">
                                                <div class="media">
                                                    <b-icon class="media-left" icon="earth"></b-icon>
                                                    <div class="media-content">
                                                        <h3>{{ item.name }}</h3>
                                                    </div>
                                                </div>
                                            </b-dropdown-item>
                                        </div>
                                  </b-dropdown>
                                </template>
                              </v-text-field>
                            </v-col>
                            <v-col>
                              <v-text-field
                                v-model="filters.utm_source.value"
                                clearable
                                label="Utm_source"
                                type="text"
                                outlined dense hide-details
                                @click:clear="filters.utm_source.typeOfSearch=''"
                              >
                                <template v-slot:append>
                                  <b-dropdown style="margin-bottom:3px;" v-model="filters.utm_source.typeOfSearch" aria-role="list">
                                        <template #trigger>
                                            <b-icon class="media-left" icon="help-circle" size="is-medium"></b-icon>
                                        </template>
                                        <div v-for="item in typeOfSearch">
                                            <b-dropdown-item :value="item.value" aria-role="listitem">
                                                <div class="media">
                                                    <b-icon class="media-left" icon="earth"></b-icon>
                                                    <div class="media-content">
                                                        <h3>{{ item.name }}</h3>
                                                    </div>
                                                </div>
                                            </b-dropdown-item>
                                        </div>
                                  </b-dropdown>
                                </template>
                              </v-text-field>
                            </v-col>
                            <v-col>
                              <v-text-field
                                v-model="filters.utm_campaign.value"
                                clearable
                                label="Utm_campaign"
                                type="text"
                                outlined dense hide-details
                                @click:clear="filters.utm_campaign.typeOfSearch=''"
                              >
                                <template v-slot:append>
                                  <b-dropdown style="margin-bottom:3px;" v-model="filters.utm_campaign.typeOfSearch" aria-role="list">
                                        <template #trigger>
                                            <b-icon class="media-left" icon="help-circle" size="is-medium"></b-icon>
                                        </template>
                                        <div v-for="item in typeOfSearch">
                                            <b-dropdown-item :value="item.value" aria-role="listitem">
                                                <div class="media">
                                                    <b-icon class="media-left" icon="earth"></b-icon>
                                                    <div class="media-content">
                                                        <h3>{{ item.name }}</h3>
                                                    </div>
                                                </div>
                                            </b-dropdown-item>
                                        </div>
                                  </b-dropdown>
                                </template>
                              </v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                              <v-text-field
                                v-model="filters.aff_sub1.value"
                                clearable
                                label="Aff_sub1"
                                type="text"
                                outlined dense hide-details
                                @click:clear="filters.aff_sub1.typeOfSearch=''"
                              >
                                <template v-slot:append>
                                  <b-dropdown style="margin-bottom:3px;" v-model="filters.aff_sub1.typeOfSearch" aria-role="list">
                                        <template #trigger>
                                            <b-icon class="media-left" icon="help-circle" size="is-medium"></b-icon>
                                        </template>
                                        <div v-for="item in typeOfSearch">
                                            <b-dropdown-item :value="item.value" aria-role="listitem">
                                                <div class="media">
                                                    <b-icon class="media-left" icon="earth"></b-icon>
                                                    <div class="media-content">
                                                        <h3>{{ item.name }}</h3>
                                                    </div>
                                                </div>
                                            </b-dropdown-item>
                                        </div>
                                  </b-dropdown>
                                </template>
                              </v-text-field>
                            </v-col>
                            <v-col>
                              <v-text-field
                                v-model="filters.aff_sub2.value"
                                clearable
                                label="Aff_sub2"
                                type="text"
                                outlined dense hide-details
                                @click:clear="filters.aff_sub2.typeOfSearch=''"
                              >
                                <template v-slot:append>
                                  <b-dropdown style="margin-bottom:3px;" v-model="filters.aff_sub2.typeOfSearch" aria-role="list">
                                        <template #trigger>
                                            <b-icon class="media-left" icon="help-circle" size="is-medium"></b-icon>
                                        </template>
                                        <div v-for="item in typeOfSearch">
                                            <b-dropdown-item :value="item.value" aria-role="listitem">
                                                <div class="media">
                                                    <b-icon class="media-left" icon="earth"></b-icon>
                                                    <div class="media-content">
                                                        <h3>{{ item.name }}</h3>
                                                    </div>
                                                </div>
                                            </b-dropdown-item>
                                        </div>
                                  </b-dropdown>
                                </template>
                              </v-text-field>
                            </v-col>
                            <v-col>
                              <v-text-field
                                v-model="filters.aff_sub3.value"
                                clearable
                                label="Aff_sub3"
                                type="text"
                                outlined dense hide-details
                                @click:clear="filters.aff_sub3.typeOfSearch=''"
                              >
                                <template v-slot:append>
                                  <b-dropdown style="margin-bottom:3px;" v-model="filters.aff_sub3.typeOfSearch" aria-role="list">
                                        <template #trigger>
                                            <b-icon class="media-left" icon="help-circle" size="is-medium"></b-icon>
                                        </template>
                                        <div v-for="item in typeOfSearch">
                                            <b-dropdown-item :value="item.value" aria-role="listitem">
                                                <div class="media">
                                                    <b-icon class="media-left" icon="earth"></b-icon>
                                                    <div class="media-content">
                                                        <h3>{{ item.name }}</h3>
                                                    </div>
                                                </div>
                                            </b-dropdown-item>
                                        </div>
                                  </b-dropdown>
                                </template>
                              </v-text-field>
                            </v-col>
                            <v-col>
                              <v-text-field
                                v-model="filters.aff_sub4.value"
                                clearable
                                label="Aff_sub4"
                                type="text"
                                outlined dense hide-details
                                @click:clear="filters.aff_sub4.typeOfSearch=''"
                              >
                                <template v-slot:append>
                                  <b-dropdown style="margin-bottom:3px;" v-model="filters.aff_sub4.typeOfSearch" aria-role="list">
                                        <template #trigger>
                                            <b-icon class="media-left" icon="help-circle" size="is-medium"></b-icon>
                                        </template>
                                        <div v-for="item in typeOfSearch">
                                            <b-dropdown-item :value="item.value" aria-role="listitem">
                                                <div class="media">
                                                    <b-icon class="media-left" icon="earth"></b-icon>
                                                    <div class="media-content">
                                                        <h3>{{ item.name }}</h3>
                                                    </div>
                                                </div>
                                            </b-dropdown-item>
                                        </div>
                                  </b-dropdown>
                                </template>
                              </v-text-field>
                            </v-col>
                            <v-col>
                              <v-text-field
                                v-model="filters.aff_sub5.value"
                                clearable
                                label="Aff_sub5"
                                type="text"
                                outlined dense hide-details
                                @click:clear="filters.aff_sub5.typeOfSearch=''"
                              >
                                <template v-slot:append>
                                  <b-dropdown style="margin-bottom:3px;" v-model="filters.aff_sub5.typeOfSearch" aria-role="list">
                                        <template #trigger>
                                            <b-icon class="media-left" icon="help-circle" size="is-medium"></b-icon>
                                        </template>
                                        <div v-for="item in typeOfSearch">
                                            <b-dropdown-item :value="item.value" aria-role="listitem">
                                                <div class="media">
                                                    <b-icon class="media-left" icon="earth"></b-icon>
                                                    <div class="media-content">
                                                        <h3>{{ item.name }}</h3>
                                                    </div>
                                                </div>
                                            </b-dropdown-item>
                                        </div>
                                  </b-dropdown>
                                </template>
                              </v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-select
                                    :items="isBlocked"
                                    label="СМС Бан?"
                                    outlined
                                    dense
                                    clearable
                                    item-text="name"
                                    item-value="value"
                                    v-model="filters.is_sms_blocked"
                                ></v-select>
                            </v-col>
                            <v-col>
                                <v-select
                                    :items="isBlocked"
                                    label="Звонки Бан?"
                                    outlined
                                    dense
                                    clearable
                                    item-text="name"
                                    item-value="value"
                                    v-model="filters.is_call_blocked"
                                ></v-select>
                            </v-col>
                            <v-col>
                                <v-select
                                    :items="isBlocked"
                                    label="СМС White list?"
                                    outlined
                                    dense
                                    clearable
                                    item-text="name"
                                    item-value="value"
                                    v-model="filters.is_sms_white"
                                ></v-select>
                            </v-col>
                            <v-col>
                                <v-select
                                    :items="isBlocked"
                                    label="Звонки White list?"
                                    outlined
                                    dense
                                    clearable
                                    item-text="name"
                                    item-value="value"
                                    v-model="filters.is_call_white"
                                ></v-select>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                              <v-text-field
                                v-model="filters.count_reg.value"
                                clearable
                                label="Сколько регистраций?"
                                type="text"
                                outlined dense hide-details
                                @click:clear="filters.count_reg.typeOfSearch=''"
                              >
                                <template v-slot:append>
                                  <b-dropdown style="margin-bottom:3px;" v-model="filters.count_reg.typeOfSearch" aria-role="list">
                                        <template #trigger>
                                            <b-icon class="media-left" icon="help-circle" size="is-medium"></b-icon>
                                        </template>
                                        <div v-for="item in typeOfSearchDigits">
                                            <b-dropdown-item :value="item.value" aria-role="listitem">
                                                <div class="media">
                                                    <b-icon class="media-left" icon="earth"></b-icon>
                                                    <div class="media-content">
                                                        <h3>{{ item.name }}</h3>
                                                    </div>
                                                </div>
                                            </b-dropdown-item>
                                        </div>
                                  </b-dropdown>
                                </template>
                              </v-text-field>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
        <v-row>
            <v-col>
                <div class="title">Всего выбрано {{ tableData.total }}</div>
            </v-col>
            <v-col>
                <div class="title">Процент дублей: {{ tableData.usersDouble }} %</div>
            </v-col>
            <v-col>
                <v-select
                    v-model="perPage"
                    @change="getUsers()"
                    :items="perPageOptions"
                    item-text="name"
                    item-value="value"
                    return-object
                    outlined
                    dense
                ></v-select>
            </v-col>
            <v-col>
                <v-btn @click="clearFilters()" color="info">Очистить фильтры</v-btn>
            </v-col>
            <v-col>
                <v-btn @click="getUsers()" color="primary">Применить</v-btn>
            </v-col>
            <v-col v-if="extendedColumns">
                <v-btn @click="deleteUsers()" color="primary">Удалить выбранных</v-btn>
            </v-col>
            <v-col v-if="extendedColumns">
                <v-btn @click="createCSV()" color="primary">Выгрузить CSV</v-btn>
            </v-col>
        </v-row>
        <b-table
            :data="tableData.results"
            :loading="loading"
            paginated
            backend-pagination
            :total="tableData.total"
            :per-page="perPage.value"
            @page-change="onPageChange"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page"
            :checked-rows.sync="checkedRows"
            checkable
            :opened-detailed="defaultOpenedDetails"
            detailed
            detail-key="id"
            backend-sorting
            :default-sort="[sortField, sortOrder]"
            @sort="onSort"
            class="users-table"
        >
            <template slot-scope="props">
                <b-table-column field="id" label="ID" style="width: 50px;" numeric sortable>
                    {{ props.row.id }}
                </b-table-column>

                <b-table-column field="email" label="Email" sortable>
                    <span>
                        {{ props.row.email }}
                    </span>
                </b-table-column>

                <b-table-column field="phone" label="Телефон" sortable>
                    <span>
                        {{ props.row.phone }}
                    </span>
                </b-table-column>

                <b-table-column field="name" label="Имя" :visible="showColumns.name" sortable>
                    {{ props.row.name }}
                </b-table-column>

                <b-table-column
                    field="second_name"
                    label="Отчество"
                    :visible="showColumns.second_name"
                    sortable
                >
                    {{ props.row.second_name }}
                </b-table-column>

                <b-table-column
                    field="surname"
                    label="Фамилия"
                    :visible="showColumns.surname"
                    sortable
                >
                    {{ props.row.surname }}
                </b-table-column>

                <b-table-column
                    field="created_at"
                    label="Дата регистрации"
                    :visible="showColumns.created_at"
                    sortable
                >
                    {{ props.row.created_at | isoToDateTime }}
                </b-table-column>

                <b-table-column field="isAdsfinSend" label="isAdsfinSend" :visible="showColumns.isAdsfinSend">
                   {{ props.row.isAdsfinSend }}
                </b-table-column>

                <b-table-column field="aff_sub1" label="aff_sub1" :visible="showColumns.aff_sub1">
                   {{ props.row.aff_sub1 }}
                </b-table-column>

                <b-table-column field="aff_sub2" label="aff_sub2" :visible="showColumns.aff_sub2">
                   {{ props.row.aff_sub2 }}
                </b-table-column>

                <b-table-column field="aff_sub3" label="aff_sub3" :visible="showColumns.aff_sub3">
                    {{ props.row.aff_sub3 }}
                </b-table-column>

                <b-table-column field="aff_sub4" label="aff_sub4" :visible="showColumns.aff_sub4">
                    {{ props.row.aff_sub4 }}
                </b-table-column>

                <b-table-column field="aff_sub5" label="aff_sub5" :visible="showColumns.aff_sub5">
                    {{ props.row.aff_sub5 }}
                </b-table-column>

                <b-table-column field="sum" label="Сумма" :visible="showColumns.sum">
                    {{ props.row.sum }}
                </b-table-column>

                <b-table-column field="utm_source" label="utm_source" :visible="showColumns.utm_source">
                    {{ props.row.utm_source }}
                </b-table-column>

                <b-table-column field="utm_campaign" label="utm_campaign" :visible="showColumns.utm_campaign">
                    {{ props.row.utm_campaign }}
                </b-table-column>

                <b-table-column field="count_reg" label="Кол-во рег" sortable :visible="showColumns.count_reg">
                    {{ props.row.count_reg }}
                </b-table-column>

                <b-table-column field="is_sms_blocked" label="Бан СМС?" :visible="showColumns.is_sms_blocked">
                    <b-checkbox v-model="props.row.is_sms_blocked"
                        @input="changeBlock('sms', 'ban', props.row.id, props.row.is_sms_blocked)">
                        {{ props.row.is_sms_blocked }}
                    </b-checkbox>
                </b-table-column>

                <b-table-column field="is_сall_blocked" label="Бан ЗВОНКОВ?" :visible="showColumns.is_call_blocked">
                    <b-checkbox v-model="props.row.is_call_blocked"
                        @input="changeBlock('call', 'ban', props.row.id, props.row.is_call_blocked)">
                        {{ props.row.is_call_blocked }}
                    </b-checkbox>
                </b-table-column>

               <b-table-column field="is_sms_white" label="White list СМС?" :visible="showColumns.is_sms_white">
                    <b-checkbox v-model="props.row.is_sms_white"
                        @input="changeBlock('sms', 'white', props.row.id, props.row.is_sms_white)">
                        {{ props.row.is_sms_white }}
                    </b-checkbox>
                </b-table-column>

                <b-table-column field="is_call_white" label="White list ЗВОНКОВ?" :visible="showColumns.is_call_white">
                    <b-checkbox v-model="props.row.is_call_white"
                        @input="changeBlock('call', 'white', props.row.id, props.row.is_call_white)">
                        {{ props.row.is_call_white }}
                    </b-checkbox>
                </b-table-column>
            </template>

            <template slot="detail" slot-scope="props">
                <div class="title">История aff_subs</div>
                <b-table :data="props.row.extra.aff_subs" :columns="nestedColumns">
                    <template slot="detail" slot-scope="prop">
                        <b-table-column field="name" label="name">
                        {{ prop.row.name}}
                        </b-table-column>
                        <b-table-column field="value" label="value">
                        {{ prop.row.value}}
                        </b-table-column>
                        <b-table-column field="date" label="date">
                        {{ prop.row.date}}
                        </b-table-column>
                    </template>
                </b-table>
                <div class="title">История устройств</div>
                <b-table :data="props.row.extra.deviceInfo" :columns="nestedColumns">
                    <template slot="detail" slot-scope="prop">
                        <b-table-column field="name" label="name">
                        {{ prop.row.name}}
                        </b-table-column>
                        <b-table-column field="value" label="value">
                        {{ prop.row.value}}
                        </b-table-column>
                        <b-table-column field="date" label="date">
                        {{ prop.row.date}}
                        </b-table-column>
                    </template>
                </b-table>
            </template>
        </b-table>
        <confirmDeletionModal
            v-bind:checkedRows="checkedRows"
            v-bind:params="params"
        ></confirmDeletionModal>
        <confirmCSVModal></confirmCSVModal>
        <addUsersModal v-bind:params="params"></addUsersModal>
    </v-content>
</template>

<script>
import MultiplySelect from "@/app/shared/components/form-inputs/MultiplySelect";
import TimePicker from "@/app/shared/components/form-inputs/TimePicker";
import confirmDeletionModal from "@/app/admin/users/shared/modals/confirmDeletionModal";
import confirmCSVModal from "@/app/admin/users/shared/modals/confirmCSVModal";
import addUsersModal from "@/app/admin/users/shared/modals/addUsersModal.vue";

export default {
    name: "UserTable",
    components: {
        MultiplySelect,
        TimePicker,
        confirmDeletionModal,
        confirmCSVModal,
        addUsersModal,
    },
    props: ["extendedColumns", "canDelete", "type"],
    data() {
        return {
            // data: [],
            // total: 0,
            panel: [1],
            showDropdown: false,
            loading: false,
            sortField: "id",
            sortOrder: "desc",
            page: 1,
            perPage: {
                value: 20,
            },
            perPageOptions: [
                { name: "10 на странице", value: 10 },
                { name: "20 на странице", value: 20 },
                { name: "50 на странице", value: 50 },
                { name: "100 на странице", value: 100 },
            ],
            defaultOpenedDetails: [1],
            nestedColumns: [
                {
                    field: "name",
                    label: "Название параметра",
                },
                {
                    field: "value",
                    label: "Значение",
                },
                {
                    field: "date",
                    label: "Дата",
                },
            ],
            typeOfSearch: [
                { name: "Содержит", value: 'contains' },
                { name: "Не содержит", value: 'not contains' },
                { name: "Пустое?", value: 'empty' },
                { name: "Совпадает", value: 'equal' },
                { name: "Не требуется", value: '' },
            ],
            typeOfSearchDigits: [
                { name: "Больше", value: 'more' },
                { name: "Меньше", value: 'less' },
                { name: "Совпадает", value: 'equal' },
                { name: "Не требуется", value: '' },
            ],
            isBlocked: [{
                name: 'Да', value: true,
            }, {
                name: 'Нет', value: false,
            }]
        };
    },
    created() {
        if (this.type === 'sms'){
            this.filters.is_sms_blocked = false;
        }
        if (this.type === 'call') {
            this.filters.is_call_blocked = false;
        }
        this.getUsers();
    },
    computed: {
        showColumns() {
            return this.$store.getters.GET_SHOW_COLUMNS;
        },
        filters() {
            return this.$store.getters.GET_USERS_FILTERS;
        },
        requestFilters() {
            return this.$store.getters.GET_USERS_REQUEST_FILTERS;
        },
        params() {
            let params = {
                sort_by: this.sortField,
                order: this.sortOrder,
                page: this.page,
                perPage: this.perPage.value,
                filters: JSON.parse(JSON.stringify(this.requestFilters)),
            };

            let diff = new Date().getTimezoneOffset();

            if (params.filters.registerDate.from) {
                let some_date = new Date(params.filters.registerDate.from);
                some_date.setMinutes(some_date.getMinutes() + diff);
                params.filters.registerDate.from = some_date;
            }
            if (params.filters.registerDate.to) {
                let some_date = new Date(params.filters.registerDate.to);
                some_date.setMinutes(some_date.getMinutes() + diff);
                params.filters.registerDate.to = some_date;
            }

            return params;
        },
        tableData() {
            return this.$store.getters.GET_TABLE_DATA;
        },
        checkedRows: {
            get() {
                return this.$store.getters.GET_CHECKED_ROWS;
            },
            set(rows) {
                this.$store.dispatch("CHECKED_ROWS", rows);
            },
        },
    },
    methods: {
        getUsers() {
            this.loading = true;
            const params = {
                sort_by: this.sortField,
                order: this.sortOrder,
                page: this.page,
                perPage: this.perPage.value,
                filters: JSON.parse(JSON.stringify(this.requestFilters)),
            };

            let diff = new Date().getTimezoneOffset();

            if (params.filters.registerDate.from) {
                let some_date = new Date(params.filters.registerDate.from);
                some_date.setMinutes(some_date.getMinutes() + diff);
                params.filters.registerDate.from = some_date;
            }
            if (params.filters.registerDate.to) {
                let some_date = new Date(params.filters.registerDate.to);
                some_date.setMinutes(some_date.getMinutes() + diff);
                params.filters.registerDate.to = some_date;
            }

            this.$store
                .dispatch("GET_USERS", params)
                .then((data) => {})
                .catch((error) => {
                    this.$toaster.error("Неизвестная ошибка!");
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        deleteUsers() {
            if (this.checkedRows.length !== 0) {
                this.$store.dispatch("CONFIRM_DELETION_MODAL", true);
            }
        },
        changeBlock(typeOfNotif, typeOfProfile, id, value) {
            this.$store
                .dispatch("CHANGE_BLOCK", {'typeOfNotif': typeOfNotif, 'typeOfProfile': typeOfProfile, 'id': id , 'value': value})
                .then((data) => {})
                .catch((error) => {
                    this.$toaster.error("Неизвестная ошибка!");
                })
                .finally(() => {
                    this.loading = false;
                    this.getUsers();
                });
        },
        createCSV() {
            this.$store.dispatch("CONFIRM_CSV_MODAL", true);
        },
        addUsers() {
            this.$store.dispatch("ADD_USERS_MODAL", true);
        },
        onPageChange(page) {
            this.page = page;
            this.getUsers();
        },
        onSort(field, order) {
            this.sortField = field;
            this.sortOrder = order;
            this.getUsers();
        },
        clearFilters() {
            this.$store.dispatch("REFRESH_USER_FILTERS");
            this.getUsers();
        },
    },
    watch: {
        "tableData.results": {
            handler: function () {
                this.$emit(
                    "newdata",
                    this.tableData.results.map((x) => {
                        return {
                            name: x.phone,
                            uuid: x.uuid,
                        };
                    })
                );
            },
            deep: true,
        },
    },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
.verificated {
    color: #30a838;
}
.not_verificated {
    color: #e20000;
}
.users-table {
    overflow: auto;
    font-size: 12px;
}
</style>
